import LazyRoute, {
  LazyRouteAuthenticatedStudent,
} from 'approot/shared/routes/lazy-route';
import {
  PRIVATE_CLASS,
  PRIVATE_CLASS_ASSESSMENT,
  PRIVATE_CLASS_LESSON,
  PRIVATE_CLASS_LOGIN,
  PRIVATE_CLASS_TOKEN,
  PRIVATE_STUDENTS,
  PRIVATE_STUDENT_CLASSES,
} from 'global/private-routes.constants';
import {
  PUBLIC_STUDENTS_BASE,
  PUBLIC_STUDENT_SIGNIN,
  PUBLIC_STUDENT_SIGNIN_EMAIL,
} from 'global/public-routes.constants';

const StudentRoutes = [
  {
    path: PRIVATE_CLASS_ASSESSMENT,
    component: LazyRouteAuthenticatedStudent(
      () => import('approot/student-assessment/student-assessment-wrapper')
    ),
  },
  {
    path: PRIVATE_CLASS_LESSON,
    component: LazyRouteAuthenticatedStudent(
      () => import('approot/student-lesson/student-lesson-wrapper')
    ),
  },
  {
    path: [PUBLIC_STUDENT_SIGNIN, PRIVATE_CLASS_LOGIN],
    component: LazyRoute(
      () =>
        import('approot/shared/signin/student-passcode-signin/student-passcode-signin-page'),
      false,
      true
    ),
  },
  {
    path: PRIVATE_CLASS_TOKEN,
    component: LazyRoute(
      () => import('approot/student-class-to-do/student-class-to-do-qrhandler'),
      false,
      true
    ),
  },
  {
    path: PRIVATE_CLASS,
    component: LazyRoute(
      () => import('approot/student-assignments/student-assignments-wrapper'),
      false,
      true
    ),
  },

  {
    path: PRIVATE_STUDENT_CLASSES,
    component: LazyRoute(
      () => import('approot/students/student-classes'),
      true,
      true
    ),
  },
  {
    path: [PUBLIC_STUDENTS_BASE, PRIVATE_STUDENTS],
    component: LazyRoute(
      () => import('approot/shared/signin/signin-student'),
      false,
      true
    ),
  },
  {
    path: PUBLIC_STUDENT_SIGNIN_EMAIL,
    component: LazyRoute(
      () =>
        import('approot/shared/signin/student-signin/student-signin-email/student-signin-email'),
      false,
      true
    ),
  },
];

export default StudentRoutes;
